export default {
  VIEW_BOOKING_ID: "view-booking-id",
  EDIT_BOOKING_ID: "edit-booking-id"
};
